let listenersAttached = false;

function handleMouseEnter() {
  const container = document.querySelector('.toastNot-container');
  if (!container) return;

  const toasts = Array.from(container.querySelectorAll('.toastNot'));

  toasts.forEach((t, idx) => {
    const reverseIdx = toasts.length - 1 - idx;
    t.style.transform = `translateY(-${reverseIdx * 90}px) translateX(0px)`;
    t.style.zIndex = 1000 + idx;

    const prog = t.querySelector('.toast-progress');
    if (prog) {
      prog.style.animationPlayState = 'paused';
    }
    if (t.dataset.timeoutId) {
      clearTimeout(parseInt(t.dataset.timeoutId));
    }
  });
}

function handleMouseLeave() {
  const container = document.querySelector('.toastNot-container');
  if (!container) return;

  const toasts = Array.from(container.querySelectorAll('.toastNot'));

  toasts.forEach((t) => {
    const prog = t.querySelector('.toast-progress');
    if (prog) {
      prog.style.animationPlayState = 'running';

      const computedStyle = window.getComputedStyle(prog);
      const currentWidth = parseFloat(computedStyle.width);
      const totalWidth = parseFloat(window.getComputedStyle(t).width);
      const remainingPercent = currentWidth / totalWidth;

      const animationDuration = parseFloat(prog.style.animation.match(/[\d.]+/)[0]) * 1000;
      const remainingTime = animationDuration * remainingPercent;

      const newTimeout = setTimeout(() => closeToast(t), remainingTime);
      t.dataset.timeoutId = newTimeout;
    }
  });

  stackToasts();
}

/**
 * Show a toast notification with stacking capability
 * @param {string} type - Type of toast: 'success', 'error', 'info', 'warning'
 * @param {string} title - Toast title
 * @param {string} message - Toast message
 * @param {number} duration - Duration in milliseconds (default: 5000ms)
 */
export function showToast(type, title, message, duration = 5000) {
  const toast = document.createElement('div');
  toast.className = `toastNot ${type}`;
  let icon = '';
  switch (type) {
    case 'success':
      icon = 'fa-circle-check';
      break;
    case 'error':
      icon = 'fa-circle-xmark';
      break;
    case 'info':
      icon = 'fa-circle-info';
      break;
    case 'warning':
      icon = 'fa-triangle-exclamation';
      break;
    default:
      icon = 'fa-bell';
  }

  toast.innerHTML = `
    <div class="toast-icon">
      <i class="fas ${icon}"></i>
    </div>
    <div class="toast-content">
      <div class="toast-title">${title}</div>
      <div class="toast-message">${message}</div>
    </div>
    <button class="toast-close">
      <i class="fas fa-times"></i>
    </button>
    <div class="toast-progress"></div>
  `;

  let container = document.querySelector('.toastNot-container');
  if (!container) {
    container = document.createElement('div');
    container.className = 'toastNot-container';
    document.body.appendChild(container);
  }

  if (!listenersAttached) {
    container.addEventListener('mouseenter', handleMouseEnter);
    container.addEventListener('mouseleave', handleMouseLeave);
    listenersAttached = true;
  }

  container.appendChild(toast);

  const closeButton = toast.querySelector('.toast-close');
  closeButton.addEventListener('click', () => closeToast(toast));

  const progress = toast.querySelector('.toast-progress');
  progress.style.animation = `progress-shrink ${duration / 1000}s linear forwards`;

  const timeoutId = setTimeout(() => closeToast(toast), duration);
  toast.dataset.timeoutId = timeoutId;

  setTimeout(() => {
    toast.classList.add('show');
    setTimeout(() => stackToasts(), 100);
  }, 10);
}

function stackToasts() {
  const container = document.querySelector('.toastNot-container');
  if (!container) return;

  const toasts = Array.from(container.querySelectorAll('.toastNot'));

  toasts.forEach((toast, idx) => {
    const reverseIdx = toasts.length - 1 - idx;
    toast.style.transform = `translateY(-${reverseIdx * 10}px) translateX(${reverseIdx * 5}px)`;
    toast.style.zIndex = 1000 + idx;
  });
}

function closeToast(toast) {
  if (toast.dataset.timeoutId) {
    clearTimeout(parseInt(toast.dataset.timeoutId));
  }

  toast.classList.remove('show');

  setTimeout(() => {
    if (toast.parentElement) {
      toast.remove();
      stackToasts();
    }
  }, 300);
}